<template>
  <div
    id="popup"
    class="absolute bottom-0 left-1/2 z-20 flex w-fit translate-y-[120%] -translate-x-1/2 items-center rounded-sm bg-primary-blue py-3 px-5 text-white transition-all"
  >
    <CheckmarkIcon class="mr-3 h-4 w-4 shrink-0 !text-white" />
    <p class="relative z-10 mr-5 whitespace-nowrap !text-base">
      <slot />
    </p>
    <div
      class="absolute -top-0 left-1/2 z-0 h-3 w-3 -translate-y-1/2 -translate-x-1/2 rotate-45 bg-primary-blue"
    />
  </div>
</template>
